/**
 * GamePersonaGate — RPS play routes require the shared DM/Celeb Room persona.
 * Redirects to /dm/users so the operator can sign in as a real user.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDmPersona } from '../context/DmPersonaContext';

export default function GamePersonaGate({ children }) {
  const { isAuthenticated, loading } = useDmPersona();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <span className="text-dark-text-secondary text-sm">Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectTo = location.pathname + location.search;
    return (
      <Navigate
        to={`/dm/users?redirect=${encodeURIComponent(redirectTo)}`}
        replace
      />
    );
  }

  return children;
}
